
import { mapState } from 'vuex'

export default {
  props: {
    isSmall: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('cart', ['cart']),
  },

  methods: {
    removeVoucher(code) {
      this.$store.dispatch('cart/removeVoucher', code)
    },
  },
}
